export const PRODUCTS = [
  {
    id: '1',
    isHasSizes: true,
    category: { name: 'Футболка' },
    image:
      'https://www.notion.so/image/https%3A%2F%2Fprod-files-secure.s3.us-west-2.amazonaws.com%2F62763b15-906b-40b3-862b-867be8f6bb28%2Ff256eaa6-f974-4998-b1aa-1b61729d02b6%2FCard_pic.png?table=block&id=07b807bc-fe77-4b75-bf32-482d89127f6d&spaceId=62763b15-906b-40b3-862b-867be8f6bb28&width=2000&userId=2741abc2-75dd-4832-9063-4f0b928741d6&cache=v2',
    name: 'IT-Пузырь',
    description: 'Тряпка для мужиков с круглым авторитетом',
    price: 1399,
    oldPrice: 1599,
  },
  {
    id: '2',
    isHasSizes: true,
    category: { name: 'Футболка' },
    image:
      'https://www.notion.so/image/https%3A%2F%2Fprod-files-secure.s3.us-west-2.amazonaws.com%2F62763b15-906b-40b3-862b-867be8f6bb28%2Ff52c03a8-3bd3-46e6-b321-6e81df0c651b%2FCard_pic-2.png?table=block&id=9782298b-86dd-45e0-aca8-93bb2a9b1a00&spaceId=62763b15-906b-40b3-862b-867be8f6bb28&width=2000&userId=2741abc2-75dd-4832-9063-4f0b928741d6&cache=v2',
    name: 'Меня мама любит',
    description: 'Не, ну по-факту же',
    price: 1299,
    oldPrice: 1499,
  },
  {
    id: '3',
    isHasSizes: true,
    category: { name: 'Футболка' },
    image:
      'https://kolchanov.notion.site/image/https%3A%2F%2Fprod-files-secure.s3.us-west-2.amazonaws.com%2F62763b15-906b-40b3-862b-867be8f6bb28%2Fdfae2391-e30f-4744-9bfd-8fc7eed3a2d4%2F3925-t-shirt-black-shirt-image-png.png?table=block&id=72fc0c27-ac19-4504-b45c-577d5a6eb66d&spaceId=62763b15-906b-40b3-862b-867be8f6bb28&width=2000&userId=&cache=v2',
    name: 'Видишь принт? Нет? А он есть',
    description:
      'Футболка с модным принтом с полностью прозрачным альфа каналом',
    price: 5999,
    oldPrice: 6599,
  },
  {
    id: '4',
    isHasSizes: true,
    category: { name: 'Футболка' },
    image:
      'https://www.notion.so/image/https%3A%2F%2Fprod-files-secure.s3.us-west-2.amazonaws.com%2F62763b15-906b-40b3-862b-867be8f6bb28%2F5766066a-0b6b-420e-bf94-5826380aa3ad%2Fi.png?table=block&id=bea780d3-8b8e-4bc1-8f9a-eb64e8b4392d&spaceId=62763b15-906b-40b3-862b-867be8f6bb28&width=2000&userId=2741abc2-75dd-4832-9063-4f0b928741d6&cache=v2',
    name: 'Для тех, кто в теме',
    description: 'Не обошлось без мемов',
    price: 10999,
    oldPrice: 11099,
  },
]
